module.exports = __webpack_public_path__ + "img/pexels-photo-4498574.1512c7c4.jpeg";